import styled from "styled-components";
import {LoadingButton} from "@unibuddy/patron";

type FeedbackButtonWrapperProps = {
    isActive: boolean;
    fillColor: string;
};

export const FeedbackButtonWrapper = styled(LoadingButton)<FeedbackButtonWrapperProps>`
    transition: 250ms;
    padding: 0px;
    border: none;
    min-width: 16px;
    max-height: 16px;
    > span > svg {
        fill: ${({isActive, fillColor}) => (isActive ? fillColor : "")};
    }
    &:hover > span > svg {
        fill: ${({isActive, fillColor}) => (isActive ? "" : fillColor)};
    }
`;
